import { Flame } from "lucide-react";
import { motion } from "framer-motion";

export const StreakBadge = ({ streak, best, size = "md", showBest = false }) => {
    const s = parseInt(streak || 0, 10);
    const sizes = {
        sm: { px: "px-1.5 py-0.5 text-[10px]", icon: "w-3 h-3" },
        md: { px: "px-2 py-0.5 text-xs", icon: "w-3.5 h-3.5" },
        lg: { px: "px-3 py-1.5 text-sm", icon: "w-4 h-4" },
    };
    const sz = sizes[size] || sizes.md;
    const intensity = Math.min(1, s / 60);
    const color = s >= 60 ? "#facc15" : s >= 30 ? "#ef4444" : s >= 15 ? "#22d3ee" : s >= 5 ? "#fb923c" : "#9ca3af";
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-md border ${sz.px} font-mono`}
            style={{
                color,
                borderColor: `${color}55`,
                background: `${color}13`,
                boxShadow: `0 0 ${4 + 14 * intensity}px ${color}55`,
            }}
            title={`${s}-day streak${showBest && best ? ` • best ${best}` : ""}`}
            data-testid="streak-badge"
        >
            <motion.span
                animate={s > 0 ? { scale: [1, 1.18, 1] } : {}}
                transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                className="inline-flex"
            >
                <Flame className={sz.icon} />
            </motion.span>
            <span>{s}</span>
            {showBest && best ? <span className="opacity-70">/ {best}</span> : null}
        </span>
    );
};
